var map = {
	"./aichi.png": "8216",
	"./akita.png": "8e94",
	"./aomori.png": "aa09",
	"./chiba.png": "3f49",
	"./ehime.png": "6278",
	"./fukui.png": "86ee",
	"./fukuoka.png": "efad",
	"./fukushima.png": "5578",
	"./gifu.png": "f323",
	"./gunma.png": "f27b",
	"./hiroshima.png": "7f9b",
	"./hokkaido.png": "e423",
	"./hyogo.png": "1065",
	"./ibaraki.png": "e115",
	"./ishikawa.png": "4ad7",
	"./iwate.png": "21be",
	"./kagawa.png": "a49a",
	"./kagoshima.png": "1ff5",
	"./kanagawa.png": "ba16",
	"./kochi.png": "cc09",
	"./kumamoto.png": "fc61",
	"./kyoto.png": "b879",
	"./meisan_roulette_anime.gif": "91e8",
	"./mie.png": "b01c",
	"./miyagi.png": "a386",
	"./miyazaki.png": "2afa",
	"./nagano.png": "8c97",
	"./nagasaki.png": "0440",
	"./nara.png": "b5ff",
	"./niigata.png": "8285",
	"./oita.png": "b700",
	"./okayama.png": "67f8",
	"./okinawa.png": "aaf8",
	"./osaka.png": "b803",
	"./saga.png": "4991",
	"./saitama.png": "84fa",
	"./shiga.png": "4ab0",
	"./shimane.png": "c65e",
	"./shizuoka.png": "a483",
	"./tochigi.png": "5f1d",
	"./tokushima.png": "309d",
	"./tokyo.png": "1046",
	"./tottori.png": "b3f0",
	"./toyama.png": "a54a",
	"./wakayama.png": "b7f4",
	"./yamagata.png": "80bf",
	"./yamaguchi.png": "cee6",
	"./yamanashi.png": "1b72"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9992";